import { useLocation, useNavigate } from "react-router-dom";
import styles from "./customerHome.module.css";
import { Col, List, Row } from "antd";
import { BsCheckCircle, BsDot, BsFillCheckCircleFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import moment from "moment";
import { GoPrimitiveDot } from "react-icons/go";
import { IMG_URL } from "../../store/Apis";
import ContractorMiddleware from "../../store/Middlewares/ContractorMiddleware";
import { useDispatch } from "react-redux";
import dummyImg from '../../assets/dummy.png';
import { FaImages } from "react-icons/fa";
import CustomerMiddleware from "../../store/Middlewares/CustomerMiddlewares";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";

const CustomerHome = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [LastJob, setLastJob] = useState([]);
    const [assignedJobs, setassignedJobs] = useState([]);
    console.log('assignedJobs', LastJob)
    const navigate = useNavigate()
    useEffect(() => {
        getLanguage();
        CustomerDashboard()
    }, []);

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem("@selectedLanguage");
            i18n.changeLanguage(language);
        } catch (e) {
            console.log(e);
        }
    };

    const CustomerDashboard = () => {
        dispatch(AuthMiddleware.getUserInfo())
        dispatch(CustomerMiddleware.CustomerDashboard())
            .then(data => {
                setLastJob(data);
                setassignedJobs(data?.assigned_jobs);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const dummyActiveJob = [
        {
            id: 1,
            taskLocation: "8675, New York City",
            time: "1:00 PM",
            date: "Jan 7, 2022",
            type: "Working",
        },
        {
            id: 2,
            taskLocation: "8675, New York City",
            time: "1:00 PM",
            date: "Jan 7, 2022",
            type: "Pending",
        },
    ];
    const renderItem = (item) => {
        return (
            <div className={styles.listItem} onClick={() => {
                navigate('/Cleaners/ActiveCleaners/Profile', {
                    state: { item, screen: 'customerCleaner' },
                })
            }}>
                <div className={styles.listHeader}>
                    <div>

                        <img src={
                            item?.cleaner_image ?
                                IMG_URL + item?.cleaner_image
                                : dummyImg
                        }
                            className={styles.claeaner_image} />

                    </div>
                    <div className={styles.content} style={{ margin: '0% 2%' }}>
                        <h1 style={{ color: 'white' }}>{item?.cleaner_name}</h1>
                        <p>{item?.service_type}</p>
                    </div>
                </div>

                <div className={styles.content}>
                    {item?.status === 'working' ? <GoPrimitiveDot size={40} color="green" /> : <GoPrimitiveDot size={40} color="red" />}
                </div>
            </div>
        );
    };

    console.log('LastJob', LastJob);

    return (
        <div className={styles.ChecklistReport_mainCon}>
            {/* <div className={styles.ChecklistReport_heading}>
                <h1>{t("Checklist Report")}</h1>
            </div> */}
            <Row className={styles.ChecklistReport_row}>
                <Col className={styles.ChecklistReport_colLeft}>
                    <div className={styles.ChecklistReport_colLeftOne}>
                        <span className={styles.ChecklistReport_num}>{LastJob?.total}</span>
                        <p className={styles.ChecklistReport_jobs}>{t("Total Jobs")}</p>
                    </div>
                    <div className={styles.ChecklistReport_colLeftTwo}>
                        <span className={styles.ChecklistReport_num}>{LastJob?.completed}</span>
                        <p className={styles.ChecklistReport_jobs}>{t("Completed Jobs")}</p>
                    </div>
                    <div className={styles.ChecklistReport_colLeftThree}>
                        <span className={styles.ChecklistReport_num}>{LastJob?.pending}</span>
                        <p className={styles.ChecklistReport_jobs}>{t("Pending Jobs")}</p>
                    </div>
                </Col>
                <div className={styles.box}>
                    {LastJob?.last_completed_job ?
                        <>
                            <div className={styles.box_sub_view}>
                                <div>
                                    <img src={LastJob?.last_completed_job?.cleaner_image ? IMG_URL + LastJob?.last_completed_job?.cleaner_image : dummyImg} className={styles.profile_image} />
                                </div>
                                <div className={styles.box_heading_view}>
                                    <h1 className={styles.box_heading}>{LastJob?.last_completed_job?.cleaner_name}</h1>
                                    <h5 className={styles.span}>{t(LastJob?.last_completed_job?.service_type)}</h5>
                                </div>

                            </div>
                            <p className={styles.text}>{LastJob?.last_completed_job?.details}</p>

                            <div className={styles.flex}>
                                <FaImages className={styles.icon} color="#f6921e" size={25} />
                                <h1 className={styles.box_headingx}>
                                    {t("Picture (Before and After Work)")}
                                </h1>
                            </div>

                            <div className={styles.box_images_container}>

                                {LastJob?.last_completed_job?.before_type?.match("video/*") || LastJob?.last_completed_job?.before_type == "video" ? (
                                    // <h1>hellooo</h1>
                                    <div className={styles.box_image_view}>
                                        <video
                                            className={styles.box_image}
                                            autoPlay
                                            controls
                                            // src={IMG_URL + LastJob?.last_completed_job?.before}
                                        ><source src={IMG_URL + LastJob?.last_completed_job?.before} /> </video>
                                        <h3 className={styles.box_headingz}>{t("Before")}</h3>
                                    </div>
                                ) : LastJob?.last_completed_job?.before_type == "photo" || LastJob?.last_completed_job?.before_type?.match("image/*") ? (
                                    <div className={styles.box_image_view}>
                                        <a
                                            href={IMG_URL + LastJob?.last_completed_job?.before}
                                            target="_blank"
                                            title="Download"
                                        >
                                            <img
                                                src={IMG_URL + LastJob?.last_completed_job?.before}
                                                className={styles.box_image}
                                            />
                                        </a>
                                        <h3 className={styles.box_headingz}>{t("Before")}</h3>
                                    </div>
                                ) : null}
                                {LastJob?.last_completed_job?.after_type == "video" || LastJob?.last_completed_job?.after_type?.match("video/*") ? (
                                    <div className={styles.box_image_view} style={{ marginLeft: '10px' }}>
                                        <video
                                            className={styles.box_image}
                                            autoPlay
                                            controls
                                        // src={IMG_URL + LastJob?.last_completed_job?.after}
                                        > <source src={IMG_URL + LastJob?.last_completed_job?.after} /> </video>
                                        <h3 className={styles.box_headingz}>{t("After")}</h3>
                                    </div>
                                ) : LastJob?.last_completed_job?.after_type == "photo" || LastJob?.last_completed_job?.after_type?.match("image/*") ? (
                                    <div className={styles.box_image_view} style={{ marginLeft: '10px' }}>
                                        <a
                                            href={IMG_URL + LastJob?.last_completed_job?.after}
                                            target="_blank"
                                            title="Download"
                                        >
                                            <img
                                                src={IMG_URL + LastJob?.last_completed_job?.after}
                                                className={styles.box_image}
                                            />
                                        </a>
                                        <h3 className={styles.box_headingz}>{t("After")}</h3>
                                    </div>
                                ) : null}
                            </div>
                        </>
                        : null}
                </div>

                <h1 className={styles.assignJobHead}>{t("Assigned Jobs")}</h1>
                <List
                    style={{ width: "100%" }}
                    //   grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
                    dataSource={assignedJobs ? assignedJobs : []}
                    //   footer={loadMore}
                    renderItem={renderItem}
                />


            </Row>
        </div>
    );
};
export default CustomerHome;
